import { Component } from '@angular/core';

@Component({
    selector: 'ah-root',
    template: ` 
            <ah-layout></ah-layout>
    `,
    standalone: false
})
export class AppComponent {
    constructor() {
    }
}
